import React, {useEffect, useState} from "react";
import { Spin, Row, Col, Space, Button, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Headings from "../../../../app/atoms/Headigs";
import { getSubUserDetail, sendEmailInvite} from "../ducks/services";

const antIcon = <LoadingOutlined spin />;

const Index = (props) => {
    const {subUserEmail, onClose} = props;
    const [load, setLoad] = useState(false);
    const sendInvite = () => {
        setLoad(true);
        const payload = { emails: [subUserEmail] };
        sendEmailInvite(payload)
            .then((response) => {
                const {data} = response

                if (data?.status == 200) {
                    setLoad(false);
                    onClose();
                    message.success(data?.message);
                }
                else
                {
                    message.error(response?.data?.header?.message)
                }
            })
            .catch((error) => {
                setLoad(false);
                onClose();
                message.error(error?.response?.data?.header?.message || "Something went wrong");
            });
    };

    return (
        <Spin indicator={antIcon} size="large" spinning={load}>
            <Row gutter={[20, 20]}>
                <Col span={24}>
                    <Headings
                        title={"Send Invite Again"}
                        titleSize={2}
                        description={`Are you sure you want to send invite on ${subUserEmail}`}
                        descClass="mb-0 c-gray"
                    />
                </Col>
                <Col span={24} className="text-right">
                    <Space align="center" direction="horizontal">
                        <Button className="w-100" size="large" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            className="w-100"
                            size="large"
                            onClick={sendInvite}
                        >
                            Send
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Spin>
    );
};

export default Index;
